import { CreateNewFieldData, ResourceType, ResourceMapperNotificationTypes } from '../types';
import i18n from 'i18next';
import { createNewField } from './createNewField';
import { getCropwiseFields } from './getCropwiseFields';

export async function createAndMapHelper({
  fieldData,
  accessToken,
  orgId,
  activeResource,
  activeResourceType,
  cropwiseProducts,
  setNotification,
  updateResources,
  handleSuccessfulMapping,
}: {
  fieldData: CreateNewFieldData;
  accessToken: string;
  orgId: string;
  activeResource: any;
  activeResourceType: ResourceType;
  cropwiseProducts: any[];
  setNotification: Function;
  updateResources: Function;
  handleSuccessfulMapping: Function;
}) {
  const fieldId = await createNewField(accessToken, fieldData);

  if (fieldId.error_type) {
    setNotification(ResourceMapperNotificationTypes.CREATE_NEW_FIELD_ERROR, {
      message: i18n.t('resource_mapper.notifications.unable_to_create_new_field'),
      description:
        fieldId?.response?.data?.message ??
        i18n.t('resource_mapper.notifications.error_creating_new_field'),
    });
    return;
  }

  const response: any = await getCropwiseFields({ org_id: orgId, access_token: accessToken });
  if (response?.error_type) {
    setNotification(ResourceMapperNotificationTypes.CREATE_NEW_FIELD_ERROR, {
      message: i18n.t('resource_mapper.notifications.unable_to_create_new_field'),
      description: response?.response?.data?.message ?? '',
    });
    return;
  }

  if (activeResourceType === ResourceType.field) {
    const resource = cropwiseProducts.find((cwr: any) => cwr.id === fieldId);
    if (!resource || !activeResource || !activeResourceType) return;

    const updatedResources = await updateResources({ ignore: false });
    if (!updatedResources) return;

    const { successes, referenceId } = updatedResources;
    handleSuccessfulMapping({
      successes,
      referenceId,
      activeResource,
      ignore: false,
    });
  }
}
